import { Component } from '@angular/core';

// What's New in a dialog, opened from the footer so people can read it without leaving their page.
@Component({
  selector: 'app-whats-new-dialog',
  templateUrl: './whats-new-dialog.component.html',
})
export class WhatsNewDialogComponent {}
